<template>
  <div class="flex slideshow-bg">
    <div class="slideshow-images">
      <transition name="slides" mode="out-in">
        <div :key="galleryIndex">
          <v-carousel
            v-show="showGallery"
            :key="current.address"
            v-model="imageIndex"
            hide-delimiter-background
            hide-delimiters
            :show-arrows="false"
            height="80vh"
            class="rounded-border"
          >
            <v-carousel-item
              v-for="image in current.images"
              :key="image.image"
              eager
            >
              <v-img
                :key="image.image"
                :src="image.image"
                eager
                cover
                class="slideshow-image"
              />
            </v-carousel-item>
          </v-carousel>
        </div>
      </transition>
    </div>

    <div class="slideshow-background pt-2">
      <transition name="fade" mode="out-in">
        <div
          :key="current.address"
          class="property-details"
        >
          <div class="left-border">
            <p class="mt-1 mb-1">
              {{ current.type }}
            </p>
            <p class="address mb-1">
              {{ formatRooms(current.rooms) }}
            </p>
            <p v-if="current.address" class="mb-0 mt-2 less-weight">
              {{ current.address }}<br>
              {{ current.district }},
              {{ current.city }}
            </p>
          </div>

          <transition name="right-slide" mode="out-in">
            <div
              v-if="current.address && addInfo"
              :key="addInfo"
              class="property-add-details"
            >
              <p>
                {{ current.area | currency({ style: 'decimal', stripZeros: true }) }} m&sup2;
                <template v-if="current.totalArea > 0">
                  / {{ current.totalArea
                    | currency({ style: 'decimal', stripZeros: true }) }} m&sup2;
                </template>
              </p>
              <template v-if="current.isRental > 0">
                <p v-if="current.rentPerMonth > 0">
                  {{ current.rentPerMonth | currency({ stripZeros: true }) }} / kk
                </p>

                <p v-else>
                  Kysy hintaa!
                </p>
              </template>

              <template v-else-if="current.isShare > 0">
                <p>Vh. {{ current.unencumberedPrice | currency({ stripZeros: true }) }}</p>

                <p>Mh. {{ current.price | currency({ stripZeros: true }) }}</p>

                <p v-if="current.energyClassCompany" class="mb-0">
                  {{ noEnergyClass[current.energyClassCompany]
                    || `Energialuokka ${current.energyClassCompany}` }}
                </p>
              </template>

              <template v-else>
                <p>
                  {{ current.price | currency({ stripZeros: true }) }}
                </p>

                <p class="mb-0">
                  {{ noEnergyClass[current.energyClass] || `Energialuokka ${current.energyClass}` }}
                </p>
              </template>
              <p>{{ formatRelease(current.release) }}</p>
            </div>
          </transition>
          <p
            v-if="false"
            class="pre mt-5"
            v-text="current.description"
          />
        </div>
      </transition>
    </div>
    <transition name="left-slide" mode="out-in">
      <div
        v-if="current.agentName"
        :key="current.address"
        class="slideshow-agent pl-6"
      >
        <v-avatar size="13vh">
          <v-img :src="current.agentImage" eager/>
        </v-avatar>
        <div>
          <p class="mb-0 bolder">
            {{ current.agentName }}
          </p>
          <p class="mb-0">
            {{ current.agentPhone }}
          </p>
          <p class="mb-0">
            {{ current.agentEmail }}
          </p>
        </div>
      </div>
    </transition>
    <div class="company-details">
      <img
        :src="current.logo"
        :style="settings.invert ? 'filter: invert()' : ''"
        style="width: 14vw;"
      >
      <p>
        {{ current.companyName }} |  {{ current.companyAddress }}
      </p>
    </div>
  </div>
</template>
<script>
import { apiGet } from '../api';
import { sleep } from '@/utils';

export default {
  data: () => ({
    settings: {
      invert: false,
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingTop: 0,
    },
    noEnergyClass: {
      ei: 'Ei energiatodistusta',
      eivaadita: 'Energiatodistusta ei vaadita',
    },
    current: {},
    imageIndex: 0,
    showGallery: false,
    galleryIndex: 0,
    addInfo: false,
    properties: [],
    index: 0,
  }),
  async mounted() {
    await this.getProperties();
  },
  methods: {
    async getProperties() {
      const response = await apiGet(`properties/slide-show/${this.$route.params.companyId}`);

      this.properties = response.properties;
      this.cycle();
    },
    formatRooms(rooms) {
      if (!rooms) return '';

      const formatted = rooms?.split('+').map(item => item.trim()).join(' + ');

      return formatted.length > 88 ? formatted.replace(/(.{86})..+/, '$1…') : formatted;
    },
    formatRelease(release) {
      return release.length > 78 ? release.replace(/(.{76})..+/, '$1…') : release;
    },
    async cycle() {
      for (const property of this.properties) {
        this.current = property;
        this.imageIndex = 0;
        setTimeout(() => {
          this.showGallery = true;
          this.galleryIndex += 1;
        }, 500);

        setTimeout(() => {
          this.addInfo = true;
        }, 1000);

        for (const image of this.current.images) { // eslint-disable-line
          await sleep(6000); // eslint-disable-line
          if (this.imageIndex < 2) {
            this.imageIndex += 1;
          }
        }

        if (this.current.images.length < 2) {
          await sleep(12000); // eslint-disable-line
        }
        await sleep(500); // eslint-disable-line
        this.showGallery = false;
        this.addInfo = false;
      }

      await this.getProperties();
    },
  },
};
</script>

<style lang="scss">
    html, body {
    overflow-y: hidden;
  }
.property-details {
  color: rgb(245, 245, 245);
  padding: 2vw;

  .address {
    font-family: "Quicksand", sans-serif !important;
    font-size: 2.2rem;
    line-height: 2.1rem;
    font-weight: 700;
  }

  p {
    margin-bottom: 0;
    font-size: 1.5rem;
    font-family: "Quicksand", sans-serif !important;
  }

  p span {
    font-size: 1.8rem;
  }

  p.pre {
    white-space: pre-wrap;
  }
}

.slides-enter-active {
  transition: all 1.5s cubic-bezier(0.23, 1, 0.32, 1);
}
.slides-leave-active {
  transition: all .4s cubic-bezier(0.19, 1, 0.22, 1);
}
.slides-enter {
  transform: translateY(-100%);
}
.slides-enter, .slides-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.slideshow-agent p {
  color: rgb(245, 245, 245);
  font-size: 1.2rem;
  font-family: "Quicksand", sans-serif !important;
}
.fade-enter-active {
  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
}
.fade-leave-active {
  transition: all .4s cubic-bezier(0.19, 1, 0.22, 1);
}
.fade-enter {
  transform: translateY(-100%);
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.left-slide-enter-active {
  transition: all .9s cubic-bezier(0.23, 1, 0.32, 1);
}
.left-slide-leave-active {
  transition: all .5s cubic-bezier(0.19, 1, 0.22, 1);
}
.left-slide-enter {
  transform: translateX(-100%);
}
.left-slide-enter, .left-slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.right-slide-enter-active {
  transition: all 1.3s cubic-bezier(0.23, 1, 0.32, 1);
}
.right-slide-leave-active {
  transition: all .2s cubic-bezier(0.19, 1, 0.22, 1);
}
.right-slide-enter {
  transform: translateX(100%);
  opacity: 0;
}
.right-slide-enter /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.slideshow-image {
  height: 80vh;
  animation: 30s ease 0s normal none infinite running zoomin;
}

@keyframes zoomin {
    0% { transform: scale(1.15, 1.15) }
    50% { transform: scale(1, 1) }
    100% { transform: scale(1.15, 1.15) }
}

.flex {
  display: flex;
  gap: 24px;
  flex-wrap: nowrap;
}

.slideshow-agent {
  display: flex;
  align-items: center;
  gap: 24px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 17vh;
}

.slideshow-bg {
  background-color: #00171f;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.slideshow-images {
  padding: 2.9vh 0 2.9vh 2.9vh;
  position: absolute;
  left: 0;
  width: 70vw;
}

.slideshow-background {
  height: 100vh;
  width: 30vw;
  margin: 0;
  position: absolute;
  right: 0;
}

.rounded-border {
  overflow: hidden;
  border-radius: 24px;
  height: 80vh;
}

.property-add-details {
  background: rgba(255, 255, 255, 0.05);
  padding: 1vw 1.5vw;
  border-radius: 24px;
  margin-top: 28px;
}

.company-details {
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  gap: 20px;
  position: fixed;
  right: 3vh;
  bottom: 1.4vh;
  color: rgb(245, 245, 245);
  font-size: 1.2rem;
  font-family: "Quicksand", sans-serif !important;

  p {
    opacity: 0.55;
  }

}

.less-opacity {
  opacity: 0.65;
}

.less-weight {
  font-weight: 400;
}

p.uppercase {
  text-transform: uppercase;
  font-family: "Roboto", sans-serif !important;
  font-size: 1.3rem;
}

.bolder {
  font-weight: 700;
}

</style>
